import { Link } from 'react-router-dom';
import petFriendlyImg from '../assets/pet-friendly.webp';
import precioJustoImg from '../assets/precio-justo.webp';
import facilitamosExperienciaImg from '../assets/facilitamos-experiencia.webp';

export function FeaturesSection() {
  const features = [
    {
      title: "Pet friendly",
      description: "Somos verdaderos amantes de los animales, especialmente de los tuyos. Sabemos que son parte de la familia y estamos totalmente en desacuerdo en cobrarte por poder disfrutar de tu experiencia junto a ellos.",
      additionalText: "Confiamos plenamente de las personas que se responsabilizan de sus acompañantes animales.",
      linkText: "Ver condiciones",
      linkTo: "/condiciones-alquiler",
      image: petFriendlyImg
    },
    {
      title: "Precio justo",
      description: "Sabemos lo que cuesta viajar y lo mucho que se gasta en vacaciones, por eso nos gusta saber que con nosotros la capacidad para extender esos momentos tan especiales del año es posible.",
      image: precioJustoImg
    },
    {
      title: "Facilitamos tu experiencia",
      description: "Sabemos que has entendido a la perfección las explicaciones sobre el funcionamiento de tu camper pero con las ganas que tienes de empezar tu experiencia \"Río\" es normal que no te acuerdes de nada! Tenemos vídeos explicativos para refrescarte la memoria.",
      image: facilitamosExperienciaImg
    }
  ];

  return (
    <section className="w-full px-4 py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col">
              <div className="relative h-0 pb-[75%] mb-6 overflow-hidden rounded-lg">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-gray-600 mb-4">{feature.description}</p>
              {feature.additionalText && (
                <p className="text-gray-600 mb-4">{feature.additionalText}</p>
              )}
              {feature.linkText && feature.linkTo && (
                <Link to={feature.linkTo} className="text-brand hover:text-brand/80 font-medium mt-auto">
                  {feature.linkText}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
